<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolXML-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select  class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector
								[ShowAll]="true"
								[ShowAllID]="SchoolSelectShowAllID"
								[ShowAllText]="SchoolSelectShowAllText"
								[IsReport]="true"
								[ReportID]="332"
							>
							</caass-schoolselector>
						</div>
					</div>

					<!--StartMonthID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">StartMonth</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="StartMonthID" [(ngModel)]="report.StartMonthID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of StartMonthList" [ngValue]="o.MonthID">
									{{ o.MonthDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--StartYearID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">StartYear</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="StartYearID" [(ngModel)]="report.StartYearID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of StartYearList" [ngValue]="o.YearID">
									{{ o.YearDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--EndMonthID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">EndMonth</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="EndMonthID" [(ngModel)]="report.EndMonthID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of EndMonthList" [ngValue]="o.MonthID">
									{{ o.MonthDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--EndYearID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">EndYear</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="EndYearID" [(ngModel)]="report.EndYearID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of EndYearList" [ngValue]="o.YearID">
									{{ o.YearDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--InfractionLevelID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">InfractionLevel</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="InfractionLevelID" [(ngModel)]="report.InfractionLevelID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of InfractionLevelList" [ngValue]="o.InfractionLevelID">
									{{ o.InfractionLevelDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--ShowDetail-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">ShowDetail</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ShowDetailID" [(ngModel)]="report.ShowDetailID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ShowDetailList" [ngValue]="o.ShowDetailID">
									{{ o.ShowDetailName }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
